<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Menu" subTitle="Forms" />

    <CreateMenu />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateMenu from "@/components/Pages/Master/Menu/CreateMenu.vue";

export default defineComponent({
  name: "CreateMenuPage",
  components: {
    PageTitle,
    CreateMenu,
  },
});
</script>
